import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class AssetLocationService extends Service {
  async getHistoric(params?: any) {
    const httpResponse = await this.httpClient.get(
      'veiculo/buscarpatiohistorico',
      {
        params: removePropertyEmpty(params)
      }
    )
    return httpResponse
  }

  async getProvider(params?: any) {
    const httpResponse = await this.httpClient.get('prestador', {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async getProviderType(params?: any) {
    const httpResponse = await this.httpClient.get('prestador/tiposprestador', {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async putCurrentYard(params: any) {
    const httpResponse = await this.httpClient.put(
      'veiculo/editarpatioatual',
      params
    )
    return httpResponse
  }
}

export const assetLocationService = new AssetLocationService()
